module.exports = __webpack_public_path__ + "img/Tech test Icon - charcoal.df0301c6.svg";